export default "__VITE_ASSET__B51ZC5uH__"